export default function Logo({ className = "h-11" }) {
    return (
        <img
            src="/logo.png"
            alt="Service & Business SRLS — logo"
            className={className + " w-auto mix-blend-screen"}
            draggable={false}
        />
    );
}
